module.exports = __webpack_public_path__ + "img/SV.45bef19b.png";